export const BRAND = {
  name: 'Flow',
  legalEntity: 'Ballee Sàrl',
  tagline: 'The Artist Management Platform',
  team: 'Flow Team',
  systemUsers: { support: 'Flow Support', notifications: 'Flow' },
  logos: {
    svg: '/flow-fmark.svg',
    emailPng: 'https://flow.ballee.app/images/flow-logo-email.png',
  },
  emails: {
    noreply: 'Flow <noreply@ballee.app>',
    notifications: 'Flow <noreply@notifications.ballee.co>',
    support: 'support@ballee.co',
    info: 'info@ballee.co',
  },
  social: { twitter: '@balleeapp' },
  urls: { app: 'ballee.app', website: 'ballee.co' },
  documents: {
    productionServices: 'Flow Production Services',
    footer: 'Flow | ballee.app | info@ballee.co',
  },
  company: {
    legalName: 'Ballee Sàrl',
    address: {
      street: '2, Rue Caroline',
      postalCode: '1003',
      city: 'Lausanne',
      country: 'Switzerland',
    },
    email: 'Hello@ballee.co',
    registrationNumber: 'CH550.1.241.695-3',
    bank: {
      beneficiary: 'Ballee Sàrl',
      iban: 'CH910024324363618101W',
      swift: 'UBSWCHZH80A',
      beneficiaryAddress: 'Rue Caroline 2, 1003, Lausanne, Switzerland',
      bankName: 'UBS SWITZERLAND AG',
      bankAddress: 'Bahnhofstrasse 45, Zürich, Switzerland',
    },
  },
} as const;
